module.exports = __webpack_public_path__ + "static/media/icon_nav_user.0eacd0b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_nav_user.svg
// module id = 628
// module chunks = 0